/* src/config/localstore.js */

import localforage from 'localforage';
import {
  SAVE_ADMIN_TOKEN,
  SAVE_ADMIN_TOKEN_FAIL,
  GET_ADMIN_TOKEN,
  GET_ADMIN_TOKEN_FAIL,
} from './constants/actionTypes';

const ADMIN_TOKEN = 'ADMIN_TOKEN';

export const saveAdminTokenAction = token => ({
  type: SAVE_ADMIN_TOKEN,
  payload: token,
});

export const saveAdminTokenFail = () => ({ type: SAVE_ADMIN_TOKEN_FAIL });

export const perform = nextAction => ({
  type: GET_ADMIN_TOKEN,
  nextAction,
});

export const getAdminTokenFail = () => ({ type: GET_ADMIN_TOKEN_FAIL });

export const saveAdminToken = token => localforage.setItem(ADMIN_TOKEN, token);
export const getAdminToken = () => localforage.getItem(ADMIN_TOKEN);
export const removeAdminToken = () => localforage.removeItem(ADMIN_TOKEN);

export const getLastMessages = () => localforage.getItem('last_messages');
export const saveLastMessages = obj => localforage.setItem('last_messages', obj);



// WEBPACK FOOTER //
// ./src/config/localstore.js